<template>
    <div>
        <div style="position:fixed;width:100%; height:100%;background:#27ae60" @click="startProgram">
            <h1 style="color:#fff">Click để bắt đầu chương trình</h1>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        startProgram() {
            this.$router.push({"name": "home"})
        }
    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/StartPage.vue